import _jsx from "@babel/runtime/helpers/jsx";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { memo, useState, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import VisibilitySensor from 'react-visibility-sensor';
import BankCardList from 'components/BankCardList';
import NoData from 'components/NoData';
import BankCardListLoader from 'components/BankCardListLoader';
import { useSelectorProps } from 'hooks';
import { fetchProductsByFilters } from 'actions';
import { List, ListHeader, TextCountWrapper, TextCount } from './styles';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx2 } from "react/jsx-runtime";

function ProductsList(_ref) {
  var visibleProducts = _ref.visibleProducts,
      productsCount = _ref.productsCount,
      isFetching = _ref.isFetching,
      isLoaded = _ref.isLoaded,
      isRequestFailed = _ref.isRequestFailed;
  var selectorProps = useSelectorProps();
  var dispatch = useDispatch();
  var history = useHistory();

  var _useState = useState(20),
      _useState2 = _slicedToArray(_useState, 2),
      itemsToShowCount = _useState2[0],
      changeItemsToShowCount = _useState2[1];

  var handleListVisibilityChange = useCallback(function (isVisible) {
    if (isVisible && visibleProducts.length > itemsToShowCount) {
      changeItemsToShowCount(itemsToShowCount + 10);
    }
  }, [visibleProducts, itemsToShowCount]);
  var handleFetchProducts = useCallback(function () {
    dispatch(fetchProductsByFilters(selectorProps));
  }, [dispatch, selectorProps]);
  var handleResetFilters = useCallback(function () {
    history.push({
      pathname: '/'
    });
  }, []);
  return /*#__PURE__*/_jsx2(_Fragment, {
    children: /*#__PURE__*/_jsx(VisibilitySensor, {
      partialVisibility: "bottom",
      onChange: handleListVisibilityChange
    }, void 0, /*#__PURE__*/_jsx(List, {}, void 0, /*#__PURE__*/_jsx(ListHeader, {}, void 0, /*#__PURE__*/_jsx(TextCountWrapper, {}, void 0, /*#__PURE__*/_jsx(TextCount, {}, void 0, /*#__PURE__*/_jsx(FormattedMessage, {
      id: "cardsListHeader.count",
      values: {
        count: productsCount
      }
    })))), isFetching && Array.from(Array(4) // eslint-disable-next-line react/no-array-index-key
    ).map(function (_, index) {
      return /*#__PURE__*/_jsx(BankCardListLoader, {}, index);
    }), isRequestFailed || !(visibleProducts != null && visibleProducts.length) && !isFetching && /*#__PURE__*/_jsx(NoData, {
      isRequestField: isRequestFailed,
      fetchData: handleFetchProducts,
      resetFilters: handleResetFilters
    }), isLoaded && visibleProducts.map(function (item, index) {
      if (index < itemsToShowCount) {
        return /*#__PURE__*/_jsx(BankCardList, {
          company: item
        }, item.id);
      }

      return null;
    })))
  });
}

ProductsList.defaultProps = {
  isFetching: false,
  isLoaded: false,
  isRequestFailed: false
};
export default /*#__PURE__*/memo(ProductsList);